import { Button, Modal, Text } from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";
import { useAppVersion } from "@/hooks/useAppVersion";

// Yeni panel sürümü deploy edilince çıkar ve kapatılamaz: kullanıcı son
// değişikliklerin yansıması için mutlaka yenilemeli. Erteleme yok.
export function AppUpdateModal() {
  const updateAvailable = useAppVersion();

  return (
    <Modal
      opened={updateAvailable}
      onClose={() => {}}
      centered
      radius="md"
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      title={<Text fw={600}>Yeni sürüm hazır</Text>}
    >
      <Text size="sm" c="dimmed" mb="lg">
        Panelin yeni bir sürümü yayınlandı. Devam etmek için sayfayı yenilemen
        gerekiyor.
      </Text>
      <Button
        fullWidth
        leftSection={<IconRefresh size={16} />}
        onClick={() => window.location.reload()}
      >
        Yenile
      </Button>
    </Modal>
  );
}
